import { DependantField, FormConfig } from '@components/Form/types';
import { isFormSectionTitleConfig } from '@components/Form/utils';

export const prefixDependantFields = (
  fields: DependantField[] | undefined,
  namePrefix: string,
): DependantField[] | undefined =>
  fields?.map((field) => ({
    ...field,
    name: `${namePrefix}${field.name}`,
    dependantFields: prefixDependantFields(
      (field as { dependantFields?: DependantField[] }).dependantFields,
      namePrefix,
    ),
  })) as DependantField[] | undefined;

export const prefixFormConfigNames = (
  formConfig: FormConfig,
  namePrefix: string,
): FormConfig =>
  formConfig.map((fieldConfig) => {
    if (isFormSectionTitleConfig(fieldConfig)) {
      return fieldConfig;
    }

    return {
      ...fieldConfig,
      name: `${namePrefix}${fieldConfig.name}`,
      dependantFields: prefixDependantFields(
        (fieldConfig as { dependantFields?: DependantField[] }).dependantFields,
        namePrefix,
      ),
    };
  }) as FormConfig;
